import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { Status } from '@core/objects/status';

@Component({
    selector: 'core-projects-next-stages-menu',
    templateUrl: './next-stages-menu.component.html',
    styleUrls: ['./next-stages-menu.component.scss']
})
export class ProjectsNextStagesMenuComponent implements OnInit {

    @Input() nextStages: Status[];

    @Output() actionStageClick = new EventEmitter<Status>();

    ngOnInit() {
      
    }

    updateStage(stage: Status){
      this.actionStageClick.emit(stage);
    }

}
